var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":'resolution-popover' + _vm.path}},[_c('a',{attrs:{"href":_vm.url + '/index.html',"target":"_blank"}},[_vm._v(_vm._s(_vm.url))])])}
var staticRenderFns = []

export { render, staticRenderFns }